import React, { useState } from 'react';
import { Link, Outlet } from 'react-router-dom';
import logo from '../Mantle Logo.png';
// The master logo is black ink on white, so on the black footer it was drawing
// nothing at all. This is the same lockup as white ink on transparency,
// generated by scripts/make-icons.ps1.
import logoWhite from '../Mantle Logo White.png';
import '../pages/Landing.css'; // All landing-page styles (mn-* classes)

const FOUNDER_EMAIL = 'info@mantlebudget.com';
const RELAUNCH = 'October 2026';

const Layout = () => {
  const [auditOpen, setAuditOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const openAudit = (e) => {
    if (e) e.preventDefault();
    setMenuOpen(false);
    setAuditOpen(true);
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="mn-page">
      {/* ---------------------------------------------------------- Nav --- */}
      <header className="mn-nav">
        <div className="mn-container mn-nav-inner">
          <Link to="/" className="mn-brand" aria-label="Mantle home" onClick={closeMenu}>
            <img src={logo} alt="Mantle — budgeting and forecasting software" width="142" height="30" />
          </Link>
          <nav className="mn-nav-links">
            <Link to="/platform">Platform</Link>
            <Link to="/services">Services</Link>
            <Link to="/industries">Industries</Link>
            <Link to="/pricing">Pricing</Link>
            <Link to="/about">About Us</Link>
          </nav>
          <div className="mn-nav-cta">
            <Link to="/login" className="mn-btn mn-btn-ghost">Login</Link>
            <button type="button" className="mn-btn mn-btn-primary" onClick={openAudit}>Book a Discovery Audit</button>
          </div>
          {/* Hamburger — visible on mobile only (see .mn-nav-toggle in Landing.css) */}
          <button
            type="button"
            className={`mn-nav-toggle ${menuOpen ? 'is-open' : ''}`}
            aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile dropdown menu */}
        <div className={`mn-nav-mobile ${menuOpen ? 'is-open' : ''}`}>
          <Link to="/platform" className="mn-nav-mlink" onClick={closeMenu}>Platform</Link>
          <Link to="/services" className="mn-nav-mlink" onClick={closeMenu}>Services</Link>
          <Link to="/industries" className="mn-nav-mlink" onClick={closeMenu}>Industries</Link>
          <Link to="/pricing" className="mn-nav-mlink" onClick={closeMenu}>Pricing</Link>
          <Link to="/about" className="mn-nav-mlink" onClick={closeMenu}>About Us</Link>
          <Link to="/login" className="mn-btn mn-btn-ghost mn-btn-lg" onClick={closeMenu}>Login</Link>
          <button type="button" className="mn-btn mn-btn-primary mn-btn-lg" onClick={openAudit}>Book a Discovery Audit</button>
        </div>
      </header>

      {/* ---------------------------------------------------- Page Content --- */}
      {/* The Outlet renders whatever child route is active. We pass openAudit via context */}
      <Outlet context={{ openAudit }} />

      {/* -------------------------------------------------------- Footer --- */}
      <footer className="mn-footer">
        <div className="mn-container">
          <div className="mn-footer-top">
            <div className="mn-footer-brand">
              <img src={logoWhite} alt="Mantle" />
              <p>
                The strategic planning and budgeting layer that connects the shop floor to the top floor, bridging complex IT infrastructure and corporate financial strategy.
              </p>
              <p style={{ marginTop: 8 }}>Mantle Software (Pty) Ltd · Cape Town, South Africa</p>
            </div>
            <div>
              <h4>Platform</h4>
              <ul>
                <li><Link to="/platform">Modules</Link></li>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/industries">Industries</Link></li>
                <li><Link to="/pricing">Pricing</Link></li>
                <li><Link to="/login">Client Login</Link></li>
              </ul>
            </div>
            <div>
              <h4>Company</h4>
              <ul>
                <li><button type="button" className="mn-footer-link" onClick={openAudit}>Contact Support</button></li>
                <li><a href={`mailto:${FOUNDER_EMAIL}?subject=${encodeURIComponent('Mantle — Legal enquiry')}`}>Legal</a></li>
                <li><a href={`mailto:${FOUNDER_EMAIL}?subject=${encodeURIComponent('Mantle — Privacy Policy (POPIA) request')}`}>Privacy Policy (POPIA)</a></li>
              </ul>
            </div>
          </div>
          <div className="mn-footer-bottom">
            {/* Baked in at prerender time; suppress the mismatch if the year
                rolls over before the next deploy. */}
            <span suppressHydrationWarning>© {new Date().getFullYear()} Mantle Software (Pty) Ltd. All rights reserved.</span>
            <span>Headquartered in Cape Town, South Africa.</span>
          </div>
        </div>
      </footer>

      {/* ------------------------------------------- Discovery Audit modal --- */}
      {auditOpen && (
        <div
          className="mn-modal-overlay"
          onClick={() => setAuditOpen(false)}
          role="dialog"
          aria-modal="true"
        >
          <div className="mn-modal" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="mn-modal-close" onClick={() => setAuditOpen(false)}>&times;</button>
            <span className="mn-modal-badge">Currently in transition</span>
            <h3>Thanks for your interest in Mantle</h3>
            <p>
              Mantle is in a short transition phase, so we’re not able to take on new clients or run
              Discovery Audits just yet. We expect to be fully operational from <b>{RELAUNCH}</b>.
            </p>
            <p>
              In the meantime, please drop us a line below. We’ll personally get back to you the
              moment we’re through this phase — and you’ll be first in the queue.
            </p>
            <a
              className="mn-btn mn-btn-primary mn-btn-lg mn-modal-cta"
              href={`mailto:${FOUNDER_EMAIL}?subject=${encodeURIComponent('Mantle — Discovery Audit interest')}&body=${encodeURIComponent(
                "Hi there,\n\nI'd like to register my interest in a Mantle Discovery Audit once you're through your transition phase.\n\nCompany:\nIndustry:\nNumber of sites:\nBest contact number:\n\nThanks,"
              )}`}
            >
              Email {FOUNDER_EMAIL}
            </a>
            <p className="mn-modal-foot">
              Prefer to write it yourself? Reach us directly at <a href={`mailto:${FOUNDER_EMAIL}`}>{FOUNDER_EMAIL}</a>.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Layout;